import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import './styles.css'
import { Auth } from 'aws-amplify'
import UserRolesService from '../../lib/services/userRole/UserRolesService'
import SessionService from '../../lib/services/SessionService'
import axios from 'axios'

const styles = {
    root: {
        fontFamily: '"Rubik", "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
        fontWeight: 300
    },
    header: {
        height: 60,
        // backgroundColor: '#03a9f4',
        color: 'white',
        // padding: '16px',
        fontSize: '1.5em'
    }
}

class Header extends Component {
    constructor(props) {
        super(props)

        this.state = {
            logged: 0,
            user: null,
            partnerMasquerading: null,
            events: [],
            hasUnreadEventsCount: 0,

        }
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser({
            bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        })
            .then(user => {
                console.log('Header::amplify auth user', user)
                this.setState({ logged: 1, user: user.attributes })

                // also refresh the current roles for this user
                new UserRolesService().updateUserRoles()


                this.fetchLatestEvents()

                // TODO set a inteval that fetches those last 5 events
                setInterval(()=> {
                    this.fetchLatestEvents()
                }, 30000);
                
            
            })
            .catch(err => {
                console.log('Header::amplify auth user error:', err)
                this.setState({ logged: 0 })
            })

        let partnerMasquerading = SessionService.getPartnerMasqueraded()
        if(partnerMasquerading!=null){
            this.setState({ partnerMasquerading: partnerMasquerading })
        }
        let partnerLogged = SessionService.getPartnerLogged()
        if(partnerLogged!=null){
            if(partnerLogged && partnerLogged.hasOwnProperty("partnerType")){
                let partnerType = partnerLogged.partnerType
                this.setState({partnerTypes: partnerType.split(",")})
            }
        }

    }

    fetchLatestEvents(update = false){
        let params = ''
        if(update)
            params = '&update=1'

        // GET last 5 events for this partner
        axios.get('/event?offset=0&size=5' + params).then(response => {
            console.log('fetch events response', response)

            let hasUnreadEventsCount = response.data.body.filter(el => el.unread).length

            let events = response.data.body.map(el=>{
                if(el.messageJson && el.messageJson != ''){
                    try{
                        el.messageJson=JSON.parse(el.messageJson); 
                    }catch(err){
                        console.error(err)
                    }
                }
                return el;
            })

            this.setState({events: response.data.body, hasUnreadEventsCount: hasUnreadEventsCount})
        })
    }

    updateEventsRead(){
        this.fetchLatestEvents(true)
    }

    handleSignOut = () => {
        let partnerMasqueradingSeller = SessionService.getPartnerMasqueradedSeller()
        let partnerMasquerading = SessionService.getPartnerMasqueraded()
        
        // 1) Seller - don't logout but remove only the masqueraded cookie + then redirect in the correct site
        if(partnerMasqueradingSeller){
            SessionService.deletePartnerMasqueradingSeller()

            let url = 'https://seller.audiencerate.com/'
            if (window.location.host === 'ardashboard-dev.audiencerate.com') url = 'https://arseller-dev.audiencerate.com/'

            window.location.href = url
            return
        }

        // 2) Partner masqueraded - don't logout but remove only the masqueraded cookie
        if(partnerMasquerading != null){
            SessionService.deletePartnerMasquerading()
            this.props.history.push('/')
            window.location.reload()
            return
        }

        // 3) else call the normal Cognito sign out - logout so we will delete all cookies + Cognito Auth cookies
        Auth.signOut()
            .then(data => {
                console.log('Cognito sign out:', data)

                // logout cleaning up cookies
                SessionService.logout()

                window.location.href = '/signin'
            })
            .catch(err => console.log('Cognito sign out error:', err))
    }
   
    showPartnerType(type, destinationSite){
        return this.state.partnerTypes && this.state.partnerTypes.indexOf(type) && window.location.host.indexOf(destinationSite) == -1
    }

    isDev(){
        return window.location.host.indexOf("-dev.audiencerate.com") != -1 || window.location.host.indexOf("localhost") != -1 ;
    }

    // render links, for prod or dev sites
    renderPartnerTypeLinks(){
        let links = []

        if( !this.isDev() ){ 

            if(this.showPartnerType("SELLER", "seller.audiencerate.com") ){
                links.push(<span style={{'padding-right': '10px'}}>
                        <a style={{'fontSize': '14px'}} href="https://seller.audiencerate.com">Seller</a>
                    </span>)
            } 
            if(this.showPartnerType("MARKETER", "market.audiencerate.com") ){
                links.push(<span style={{'padding-right': '10px'}}>
                        <a style={{'fontSize': '14px'}} href="https://market.audiencerate.com">Marketplace</a>
                    </span>)
            } 
            if(this.showPartnerType("DATA_PROVIDER", "app.audiencerate.com") ){
                links.push(<span style={{'padding-right': '10px'}}>
                        <a style={{'fontSize': '14px'}} href="https://app.audiencerate.com">Dataprovider</a>
                    </span>)
            }

        } else {

            if(this.showPartnerType("SELLER", "arseller-dev.audiencerate.com") ){
                links.push(<span style={{'padding-right': '10px'}}>
                        <a style={{'fontSize': '14px'}} href="https://arseller-dev.audiencerate.com">Seller</a>
                    </span>)
            } 
            if(this.showPartnerType("MARKETER", "armarket-dev.audiencerate.com") ){
                links.push(<span style={{'padding-right': '10px'}}>
                        <a style={{'fontSize': '14px'}} href="https://armarket-dev.audiencerate.com">Marketplace</a>
                    </span>)
            }
            if(this.showPartnerType("DATA_PROVIDER", "ardashboard-dev.audiencerate.com")  ){
                links.push(<span style={{'padding-right': '10px'}}>
                        <a style={{'fontSize': '14px'}} href="https://ardashboard-dev.audiencerate.com">Dataprovider</a>
                    </span>)
            }

        }

        // add title 
        if(links.length > 0){
            links.unshift(<b style={{'color': 'black', 'font-size': '14px', 'margin-top': '10px', 'padding-right': '10px'}} >Access other Platforms:</b>)
        }

        return links        
    }

    render() {
        const { commit } = require('../../version.json')
        const rootStyle = this.props.style ? { ...styles.root, ...this.props.style } : styles.root
        return (
            <div style={rootStyle}>
                <div style={styles.header} className="d-flex justify-content-start">
                    {this.props.title}
                    <div className="ml-auto p-2">
                        <div className="row">
                            
                            
                            {this.renderPartnerTypeLinks()}

                            

                            <div class="btn-group" style={{
                                    "margin-right": "-30px",

                            }}>
                                <button 
                                    className="btn btn-secondary header-btn dropdown" onClick={()=> this.updateEventsRead()}

                                href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                
                                    <div style={{
                                        "color":"#333","fontSize":"18px",
                                        "cursor": "pointer", 
                                        }}>
                                            <a style={{
                                                "padding":"10px", "color": "black"
                                            }}
                                            href="/events">
                                                <i class="fa fa-bell-o" aria-hidden="true"></i>
                                                {this.state.hasUnreadEventsCount > 0 && (
                                                    <span class="badge badge-primary" style={{'fontSize': '11px'}}>{this.state.hasUnreadEventsCount}</span>
                                                )}
                                            </a>
                                    </div>

                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdown">
                                
                                    {this.state.events.map(el =>(
                                        <a class="dropdown-item" href="/events">
                                            <span style={{'color': '#666', 'fontSize': '11px'}}>{new Date(el.creation).toLocaleDateString()} {new Date(el.creation).toLocaleTimeString()}</span><br/>
                                            {el.description} &#160;
                                            {el.status === 'DONE' && el.messageJson && el.messageJson.errors && (
                                                <span class="badge badge-danger">ERROR</span>
                                            )}
                                            {el.status === 'DONE' && el.messageJson && !el.messageJson.errors && (
                                                <span class="badge badge-success">{el.status}</span>
                                            )}
                                            {el.status === 'PENDING' && (
                                                <span class="badge badge-secondary">{el.status}</span>
                                            )}
                                            {el.status === 'IN PROCESS' && (
                                                <span class="badge badge-info">{el.status}</span>
                                            )}
                                        </a>
                                    ))}
                                
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" href="/events">Event Log</a>

                                </div>
                            </div>



                            <div className="col">
                                {this.state.partnerMasquerading && this.state.partnerMasquerading.partnerId && (
                                    <div>
                                        <div
                                            title={'Masquerading as: ' + this.state.partnerMasquerading.friendlyName}
                                            className="badge badge-primary"
                                            style={{
                                                fontSize: '13px',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                maxWidth: '260px',
                                                marginTop: '10px'
                                            }}>
                                            <i className="fa fa-user"></i> {this.state.partnerMasquerading.friendlyName} -{' '}
                                            {this.state.partnerMasquerading.partnerId}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="dropdown">
                                <button
                                    className="btn btn-secondary header-btn dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.state.user && (
                                        <span>
                                            {`${this.state.user.name} `}
                                            {this.state.user.family_name && this.state.user.family_name}
                                        </span>
                                    )}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button className="dropdown-item" label="Sign Out" onClick={this.handleSignOut}>
                                        Sign Out
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.children}
                <div className="d-flex justify-content-center align-items-center dashboard--footer">
                    {new Date().getFullYear()} &#169; <a href="http://www.audiencerate.com/">AudienceRate LTD</a>&#160;-&#160;
                    <a href="http://www.audiencerate.com/privacy/">Privacy Policy</a>
                    <span style={{ marginLeft: 80 }}>
                        Documentation:{' '}
                        <a target="_blank" href="/doc/home">
                            Technical
                        </a>{' '}
                        -{' '}
                        <a target="_blank" href="https://apidocs.audiencerate.com/">
                            API
                        </a>
                    </span>
                    <span style={{ marginLeft: 100 }}>
                        Build <code>{commit}</code>
                    </span>
                </div>
            </div>
        )
    }
}

export default withRouter(Header)
